<template>
  <v-row class="pt-0" style="height: 100%;">
    <Teleport to="#settings-group-header">
      Магазин {{ shop_id }}
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <v-container v-if="!shop_model.deleted">
        <v-row>
          <v-col>
            <v-btn @click="deleteShop" color="error">
              Удалить
            </v-btn>
          </v-col>
          <v-col>
            <v-btn @click="deactivateShop" color="grey-darken">
              {{ shop_model.enabled ? 'Деактивировать' : 'Активировать' }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn @click="saveShop" color="primary">
              Сохранить
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </Teleport>
    <v-col cols="12">
      <ShopEdit v-model="shop_model"
        :original_value="original_value"
        :loading="loading"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Teleport from 'vue2-teleport';
import ShopEdit from '@/components/shops/ShopEdit.vue'

export default{

  props:{
    shop_id: [Number, String]
  },

  data: () => ({
    loading: false,
    shop_model: {
      enabled: true,
      name: ''
    },
    payment_agent: {
      is_test: true,
      key: null,
      sector: null,
      currency: null,
      url: null,
      fail_url: null,
      time_pay: null,
      pay_agent: null,
      pay_description: null,
      nds: null,
      taxation_system: null
    },
    original_value: {
      name: ''
    }
  }),

  computed:{
    ...mapGetters('data', ['shop', 'dealers', 'template']),
    
    mini(){
      return this.$vuetify.breakpoint.mdAndDown
    },
  },

  methods: {
    ...mapActions('data', ['shop_by_id','shop_update', 
    'shop_delete', 'shop_deactivate', 'shop_template']),

    ...mapActions(['throwTimeoutMessage']),

    async saveShop(){
      this.loading = true;
      
      console.log('this.shop',this.shop(this.shop_model.id))
      await this.shop_update(this.shop_model);
      console.log('this.shop',this.shop(this.shop_model.id))
      this.shop_model = this.shop(this.shop_model.id);
      this.original_value = {...this.shop_model};
      this.loading = false;
      this.throwTimeoutMessage({
        text: 'Успешно сохранено',
        message_class: 'success'
      })
    },

    async deleteShop(){
      await this.shop_delete(this.shop_model.id);
      this.$router.push({name: 'Shops'});
      this.throwTimeoutMessage({
        text: 'Удаление завершено успешно',
        message_class: 'success'
      })
    },

    async deactivateShop(){
      this.loading = true;
      await this.shop_deactivate(this.shop_model.id);
      this.shop_model = this.shop(this.shop_id);
      this.original_value = {...this.shop_model};
      this.loading = false;
    },
  },

  async mounted(){
    this.loading = true;

    try {
      let shop = this.shop(this.shop_id);

      if (!shop) {
        await this.shop_by_id(this.shop_id);
        shop = this.shop(this.shop_id);
      }

      if (!shop) {
        console.error('Магазин не найден:', this.shop_id);
        return;
      }

      this.shop_model = {...shop};

      if (this.shop_model.payment_agent === null) {
        this.shop_model.payment_agent = {...this.payment_agent};
      }

      if (!this.template) {
        await this.shop_template();
      }

      this.original_value = {...this.shop_model};

    } finally {
      this.loading = false;
    }
  },
  
  components:{
    Teleport,
    ShopEdit
  }
}

</script>